import { motion } from "framer-motion";
import { CalendarPlus, Check, RotateCcw } from "lucide-react";
import { EASE } from "@/components/Reveal";

const gcalStamp = (iso) => new Date(iso).toISOString().replace(/[-:]|\.\d{3}/g, "");

const googleCalendarUrl = (b) => {
  const p = new URLSearchParams({
    action: "TEMPLATE",
    text: `AiCendor consultation — ${b.topic}`,
    dates: `${gcalStamp(b.slot_start)}/${gcalStamp(b.slot_end)}`,
    details: "30-minute consultation with AiCendor. The joining link will follow by email from the AiCendor team.",
    ctz: b.timezone,
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
};

export const BookingConfirmed = ({ booking, onReset }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: EASE }}
    className="glass-panel p-8 sm:p-10"
    data-testid="booking-confirmed"
  >
    <span className="flex h-12 w-12 items-center justify-center border border-gold bg-gold/10">
      <Check className="h-5 w-5 text-gold" />
    </span>
    <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.3em] text-gold">Consultation confirmed</p>
    <h3 className="mt-4 font-display text-3xl tracking-tight sm:text-4xl" data-testid="booking-confirmed-when">
      {booking.when.replace(` (${booking.timezone})`, "")}
    </h3>
    <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">UK time · {booking.timezone}</p>
    <p className="mt-8 max-w-lg text-sm leading-relaxed text-slate-400 sm:text-base">
      Thank you, {booking.name}. A confirmation is on its way to <span className="text-white">{booking.email}</span>.
      The AiCendor team will follow up with a calendar invitation and joining link ahead of the call.
    </p>
    <div className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center">
      <a
        href={googleCalendarUrl(booking)}
        target="_blank"
        rel="noreferrer"
        data-testid="booking-add-to-calendar"
        className="btn-sweep flex items-center gap-3 border border-white/25 px-8 py-4 font-mono text-xs uppercase tracking-[0.22em] text-white"
      >
        <CalendarPlus className="h-4 w-4" /> Add to Google Calendar
      </a>
      <button
        type="button"
        onClick={onReset}
        data-testid="booking-book-another"
        className="link-underline flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-slate-400 transition-colors hover:text-white"
      >
        <RotateCcw className="h-3.5 w-3.5" /> Book another time
      </button>
    </div>
  </motion.div>
);
